import React from "react";

import KeywordReviewCrossAnalysis from "../KeywordReviewCrossAnalysis";
import KeywordReviewCrossAnalysisV2 from "../KeywordReviewCrossAnalysisV2";
import { FeatureNames } from "../types/featureNames";
import { KeywordReviewCrossAnalysisData } from "../types/keywordReviewCrossAnalysisData";

interface IOrganizationFeaturesContentProps {
  featureName: FeatureNames;
  data: KeywordReviewCrossAnalysisData | undefined;
  organizationId: string | null | undefined;
}

const OrganizationFeaturesContent: React.FunctionComponent<
  IOrganizationFeaturesContentProps
> = (props) => {
  switch (props.featureName) {
    case FeatureNames.KEYWORD_REVIEW_CROSS_ANALYSIS:
      return <KeywordReviewCrossAnalysis data={props.data} />;
    case FeatureNames.KEYWORD_REVIEW_CROSS_ANALYSIS_V2:
      return props.organizationId ? (
        <KeywordReviewCrossAnalysisV2 organizationId={props.organizationId} />
      ) : null;
    default:
      return null;
  }
};

export default OrganizationFeaturesContent;
